export const Budget = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Budget',
    },
    Name: {
      'bulk-upload-header': 'Budget Name',
    },
    Amount: {
      'bulk-upload-header': 'Budget',
    },
    Type: {
      'bulk-upload-header': 'Budget Type',
      'bulk-upload-mapper': function (value) {
        const mapping = {
          Monthly: 'Monthly',
          DailyStandard: 'DailyBudgetStandard',
          DailyAccelerated: 'DailyBudgetAccelerated',
          LifetimeBudgetStandard: 'LifetimeBudgetStandard',
        };

        return mapping[value];
      },
    },
  },
};
